export const API_ERROR_EVENT = 'api-error-alert';
export const PEP_API_PATH = '/proxy/api/v1';
export const PEP_API_PATH_V2 = '/api/v2';
export const PEP_API_PATH_V3 = '/proxy/api/v3';
